import React, {useState} from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import dayjs from 'dayjs';
import {Button, ButtonRow} from '@deviceinsight/ng-ui-basic-components';
import * as translations from '../tenantscheduler/translations';
import DateTimeInput from '../../common/DateTimeInput';

type Props = {
	loading: boolean;
	initialDate: string;
	isWorkspace: boolean;
	latestExecutionDate: string;
	onSubmit: (arg0: string) => void;
	onCancel: () => void;
};

const ExecutionDateForm = ({loading, initialDate, isWorkspace, onSubmit, onCancel, latestExecutionDate}: Props) => {
	const [date, setDate] = useState<string | null | undefined>(initialDate);
	const saveButton = isWorkspace
		? translations.scheduleSaveButtonWorkspace
		: translations.scheduleSaveButtonInventory;

	const submit = () => {
		if (date && dayjs(date).isValid()) {
			onSubmit(date);
		}
	};

	return (
		<>
			<div className="field">
				<label>
					<Trans i18nKey={translations.actualExecutionDateLabel.id}>
						{translations.actualExecutionDateLabel.defaultValue}
					</Trans>
				</label>
				<div>
					<DateTimeInput
						step={30}
						minDate={new Date(Date.now())}
						maxDate={new Date(latestExecutionDate)}
						timestamp={date || initialDate}
						onChange={(date: string | null | undefined) => {
							setDate(date);
						}}
					/>
				</div>
			</div>
			<ButtonRow
				style={{
					justifyContent: 'space-between'
				}}>
				<Button data-testid="save-execution-date-button" primary disabled={loading || !date} onClick={submit}>
					<Trans i18nKey={saveButton.id}>{saveButton.defaultValue}</Trans>
				</Button>
				<Button
					data-testid="cancel-execution-date-button"
					onClick={onCancel}
					style={{
						marginRight: 0
					}}>
					<Trans i18nKey={translations.cancelButton.id}>{translations.cancelButton.defaultValue}</Trans>
				</Button>
			</ButtonRow>
		</>
	);
};

export default ExecutionDateForm;
